import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Card, Col, Container, Row } from 'react-bootstrap';
import Button from '../../../components/Button';
import GenericCards from '../../../components/GenericCards';
import Link from '../../../components/Link';
import useModal from '../../../hooks/useModal';
import { DateFormats, formatDate } from '../../../utils/utils';
import RetireSummaryModal from './actionsRequired';
import MailInFormsModal from './MailInFormsModal';

const RetireOnlineSuccessScreen = () => {
  const [
    showMailInFormsModal,
    handleShowMailInFormsModal,
    handleCloseMailInForms,
  ] = useModal();

  const [showSummaryModal, handleShowSummaryModal, handleCloseSummaryModal] =
    useModal();

  const initialDate = new Date();

  return (
    <section className="d-lg-flex flex-lg-row pt-10">
      <Container className={`p-0 custom-outlined-card`}>
        <Card className={'bg-white'}>
          <Card.Title>
            <Row>
              <Col className="mb-0 h5 flex-column">
                You have completed your online retirement{' '}
              </Col>
            </Row>
          </Card.Title>
          <Card.Body>
            <Row>
              <Col className="col-12 col-lg-3">
                <GenericCards
                  variant="transperant"
                  className="d-flex flex-column rounded-1 p-lg-0 py-md-2"
                >
                  <h5 className="lh-sm mb-0 dark text-reset">
                    Submission Details
                  </h5>
                  <span className="fw-light text-caption lh-xs">
                    {`Submitted: ${formatDate(initialDate, DateFormats.SHORT)}`}
                  </span>
                  <span className="fw-light text-caption lh-xs">
                    Status: Completed
                  </span>
                  <span>
                    <Button
                      variant="primary-outline"
                      className="mt-9"
                      onClick={handleShowSummaryModal}
                    >
                      Show Summary
                    </Button>
                  </span>
                </GenericCards>
              </Col>
              <Col className="col-12 col-lg-4">
                <GenericCards
                  variant="transperant"
                  className="d-flex flex-column p-lg-0 rounded-1 dark py-md-2"
                >
                  <h5 className="lh-sm mb-0 text-reset">Download Record</h5>
                  <span className="fw-light text-caption lh-xs">
                    You can find the verification document under the document
                    center.
                  </span>
                  <span>
                    <Link
                      href={`${
                        process.env.PUBLIC_URL
                      }/${'retirement-package-demo-example_v1.pdf'}`}
                      target={'_blank'}
                    >
                      <Button
                        variant="primary-outline"
                        className="mt-3 mb-3"
                        leftIcon={light('file-arrow-down')}
                      >
                        Download/Print
                      </Button>
                    </Link>
                  </span>
                </GenericCards>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
      <MailInFormsModal
        showModal={showMailInFormsModal}
        handleClose={handleCloseMailInForms}
      />
      <RetireSummaryModal
        showRetireSummaryModal={showSummaryModal}
        handleCloseRetireSummaryModal={handleCloseSummaryModal}
      />
    </section>
  );
};

export default RetireOnlineSuccessScreen;
